import { MatDialogConfig } from '@angular/material/dialog';
import { CREATE_PURCHASE_NOTE_PANEL_CLASS } from 'src/features/purchase-note/create-purchase-note/ui/create-purchase-note/create-purchase-note-dialog.config';
import { PurchaseNotePdfDialogData } from './purchase-note-pdf-dialog.component';

export function buildPurchaseNotePdfDialogConfig(
  data: PurchaseNotePdfDialogData
): MatDialogConfig<PurchaseNotePdfDialogData> {
  return {
    width: 'min(1120px, 96vw)',
    maxWidth: '96vw',
    height: 'min(92vh, 900px)',
    maxHeight: '92vh',
    panelClass: [CREATE_PURCHASE_NOTE_PANEL_CLASS, 'order-pdf-dialog-panel'],
    autoFocus: false,
    data
  };
}
